/*
  This will be used for updating:
  Student - Home address fields
*/
import React,{Component} from "react";
import _ from "lodash";
import Joi from "@hapi/joi"
import Select from "react-select";


import http             from "../../../../../../services/httpService";
import {getUSStateList} from "../../../../../../services/dropDownListsService";
import {getCountryList} from "../../../../../../services/dropDownListsService";
import UserService      from "../../../../../../services/userService";
import SchoolService      from "../../../../../../services/schoolService";

import BaseForm from "../../../../../BaseClass/Form"
import FormErrorWidget from "../../../../../Common/FormErrorWidget";

import {scrollTop}     from '../../../../../../utils/helperUtils';
import {renderError}   from '../../../../../../utils/errorUtils';
import customToast     from '../../../../../Common/CustomToast';

// reactstrap components
import {
    Badge,
    Button,
    Container,
    Card,
    CardBody,
    Row,
    Col,
    Form,
    FormGroup, 
    Label, 
    Input, 
    InputGroupAddon,
    InputGroupText,
    InputGroup,
} from "reactstrap";

class StudentHomeAddressInformation extends BaseForm{
    divAreaToScrollForError = "description-areas"

    validationSchema = "";

    addressSchema = Joi.object({
        addressLine1: Joi.string().required().label('Address Line 1'),
        city:Joi.string().required().label('City'),
        state:Joi.object().keys({
            value:Joi.string().required(), 
            label:Joi.any().optional(),
        }),
        postalCode:Joi.string().required().label('Postal Code'),
        country:Joi.object().keys({
            value:Joi.string().required().label('Country'), 
            label:Joi.any().optional(),
        }),
    }) ;

    errorMessages = {}
    
    constructor(){
        super();
        this.state = {
            stateList:[{ value: "", label: "", isDisabled: true }],
            countryList:[{ value: "", label: "", isDisabled: true }],
            data:{
                updateFlag:false,
                homeAddress:{
                    addressLine1:"",
                    city:"",
                    state:"",
                    postalCode:"",
                    country:"",

                },
            },
            errors:{},
        }
    }

    componentDidMount(){
        this.mapModelToView();
    }

    componentDidUpdate(prevProps){
        const {user} = this.props;
        const {user:previousUser} = prevProps;
        if(!_.isEqual(previousUser.primaryInformation,user.primaryInformation)){
            this.mapModelToView();
        }
            
        
    }

    getAddressForDisplay = ()=>{
        let displayAddress  = "Home address not entered.";
        const {user} = this.props;
        const {primaryInformation} = user;
        if(primaryInformation !== ""){
            const {line1:addressLine1,line2:addressLine2} = UserService.getFormattedUserHomeAddress(primaryInformation);
            if(addressLine1 && addressLine1)
                return <>{addressLine1} <br/> {addressLine2}</>;
            
        }

        return displayAddress
    }

    mapModelToView = async ()=>{
        
        try{
            const stateList = getUSStateList();
            const countryList = getCountryList();

            const {user} = this.props;
            
            const {campus_id:school_id} = user.primaryInformation;
            
            const school = {id:school_id};
        
            const data = {
                ...this.state.data,
            }

            this.setState(
                {
                    stateList,
                    countryList,
                    data,
                }
            );
        }
        catch(ex){
            console.log(`Component did mount ${ex}`);
        }

          
        
    }

    

   
    setUpdateFlagInformation = (updateFlag)=>{
        this.setState({
            data:{
                ...this.state.data,
                updateFlag,
            }
        })
    }

    //This gets executed once the parent submission process is executed
    submitLocal = async ()=>{
        const {
            handleOnSaveOfCustomerInformation,
            handleDisplayOfProcessingModal,
        } = this.props;
        
        try{
            
            handleDisplayOfProcessingModal(true);

            let {homeAddress:homeAddressFormData} = this.state.data;

            const homeAddress = {
                ...homeAddressFormData,
                state:(_.has(homeAddressFormData,['state','value'])) ? homeAddressFormData.state.value:"",
                country:(_.has(homeAddressFormData,['country','value'])) ? homeAddressFormData.country.value:"",
            };

            const formData = {
                ...this.state.data,
                homeAddress,
            }


            const {status,message,errorObject} = await UserService.viewProfileSaveStudentHomeAddress(formData);

            if(status === true){
                handleDisplayOfProcessingModal(false);
                
                //Reset form object
                let addressFormData = {...this.state.data.homeAddress}
                _.forIn(addressFormData,(v,k)=>addressFormData[k]="");
               
                this.setState({
                    data:{
                        ...this.state.data,
                        updateFlag:false,
                        homeAddress:addressFormData,
                    } 
                })
                
                customToast.success(message); 
                //Go back to the parent view for information reload
                return handleOnSaveOfCustomerInformation();
            }
        } 
        catch(ex){
            handleDisplayOfProcessingModal(false);
            /*
            400 signals validation errors from the server
            renderError() basically will display server side error other than code 400
            */
            if(ex.response && ex.response.status === 400){ 
                const errors = ex.response.data;
                this.setState({errors: errors || {}});
                if(errors){ scrollTop(this.divAreaToScrollForError); return;}
            }
            else
                renderError(ex);
        }
        
    }

    validateLocal= ()=>{
        //This is anything specific to the form like async validations
        const {updatePrimaryAddressFlag} = this.state.data;
        if(updatePrimaryAddressFlag === false) return null;

        const options = {abortEarly:false,allowUnknown:true};
        let {error:homeAddressError} = this.addressSchema.validate(this.state.data.homeAddress,options);
        
        if(homeAddressError === undefined) return null;

        const homeAddressErrors = {};
        if(homeAddressError){
            homeAddressError.details.map(
                function(errorObject){
                    const addressKey = "homeAddress";
                    const addressLabel = "Home Address: ";
                    //console.log(errorObject);
                    if(_.has(errorObject, ['context', 'key']) && _.has(errorObject, ['type'])){
                        const key = errorObject.context.key;
                        const joiType = errorObject.type;
                        //console.log(this.errorMessages);
                        if(_.has(this.errorMessages, [key, joiType]))
                            return homeAddressErrors[`${addressKey}.${errorObject.path[0]}`] = addressLabel + this.errorMessages[key][joiType];
                        else
                            return homeAddressErrors[`${addressKey}.${errorObject.path[0]}`] = addressLabel + errorObject.message;
                    }
                    else
                      return homeAddressErrors[`${addressKey}.${errorObject.path[0]}`] = addressLabel + errorObject.message;
                }.bind(this)
            );
        }
        
        const errors = {...homeAddressErrors} 
        //console.log(errors);
        return Object.keys(errors).length > 0 ? errors:null;
    }

    render(){
        const {
            user,
        } = this.props;

        
        const {data,errors,stateList,} = this.state;
        const currentAddress = this.getAddressForDisplay();

        const   {
            updateFlag,
            homeAddress,
        } = data;

        
        
        return(
            <Container id="mainContentArea">
                <Row className="title-body-row">
                    <Col>
                        <Card className="card-plain bg-white p-2 rounded-lg">
                            <CardBody>
                                {/*Error display */}
                                {!_.isEmpty(errors) &&
                                    <FormErrorWidget
                                    errors={errors}
                                    />
                                }
                                {/* End of Error display */}

                                
                                <div className="mt-2 mb-4">
                                    <h6 className="card-category">
                                        <span className="text-left">
                                            Home Address Information:
                                        </span>
                                    </h6>
                                    <hr/>
                                    <Row className="mt-2">
                                        <Col sm={4} md={2}>
                                            Home Address
                                        </Col>
                                        <Col xs="8">
                                            {currentAddress}
                                        </Col>
                                    </Row>

                                    {
                                        !updateFlag && 
                                        <Row className="mt-2">
                                            <Col xs="2">
                                            </Col>
                                            <Col xs="8">
                                                <Button 
                                                    className="btn-round mr-1"
                                                    color="default"
                                                    outline
                                                    size="sm"
                                                    onClick={()=>this.setUpdateFlagInformation(true)}
                                                >
                                                Update Address
                                                </Button>
                                            </Col>
                                        </Row>
                                    }
                                </div>
                            
                                
                                {
                                    updateFlag && 
                                    <Row >
                                        <Col>
                                            <h6 className="mb-4">Upate your home address:</h6>

                                            <FormGroup row >
                                                <Label for="addressLine1" sm={2}>Street Name</Label>
                                                <Col sm={10}>
                                                    <Input 
                                                        type="text" 
                                                        name="addressLine1" 
                                                        id="addressLine1" 
                                                        placeholder="Street Name" 
                                                        value={homeAddress.addressLine1} 
                                                        onChange={e=>{this.handleChangeNestedAttribute(e,"homeAddress")}}
                                                    />
                                                </Col>
                                                
                                            </FormGroup>
                                        
                                            <FormGroup row>
                                                <Label for="city" sm={2}></Label>
                                                <Col xs={12} sm={3}>
                                                    <Input 
                                                    type="text" 
                                                    name="city" 
                                                    id="city" 
                                                    placeholder="City" 
                                                    value={homeAddress.city} 
                                                    onChange={e=>{this.handleChangeNestedAttribute(e,"homeAddress")}}
                                                    />
                                                </Col>
                                                <Label for="state" xs={12} sm={2} className="d-block d-sm-none"></Label>
                                                <Col xs={12} sm={4}>
                                                    <FormGroup>
                                                        <Select
                                                            className="react-select react-select-default"
                                                            classNamePrefix="react-select"
                                                            name="state"
                                                            id="state"
                                                            value={homeAddress.state}
                                                            onChange={value => this.handleDropdownChangeNestedAttribute(value,"state","homeAddress",)}
                                                            options={stateList}
                                                            placeholder="State"
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col xs={12} sm={3}>
                                                    <Input 
                                                        type="text" 
                                                        name="postalCode" 
                                                        id="postalCode" 
                                                        placeholder="Zip" 
                                                        value={homeAddress.postalCode} 
                                                        onChange={e=>{this.handleChangeNestedAttribute(e,"homeAddress")}}
                                                    />
                                                </Col>
                                            </FormGroup>

                                            <FormGroup row>
                                                <Label for="country" sm={2}>Country</Label>
                                                <Col sm={10}>
                                                    <Select
                                                        className="react-select react-select-default"
                                                        classNamePrefix="react-select"
                                                        name="country"
                                                        id="country"
                                                        value={homeAddress.country}
                                                        onChange={value => this.handleDropdownChangeNestedAttribute(value,"country","homeAddress")}
                                                        options={this.state.countryList}
                                                        placeholder="Country"
                                                        autoComplete="off"
                                                    />
                                                </Col>
                                                
                                            </FormGroup>

                                            <FormGroup row className="mt-5 justify-content-between">
                                                <Col xs={{ size: 2 }}>
                                                    <Button 
                                                    className="btn-rounded btn-danger"
                                                    onClick={()=>this.setUpdateFlagInformation(false)}
                                                    >
                                                    Cancel
                                                    </Button>
                                                </Col>
                                                <Col xs={{ size: 6}} sm={{ size: 4}} className="text-right">
                                                    <Button 
                                                    className="btn-rounded btn-danger"
                                                    onClick={this.submitForm}
                                                    >
                                                    Save
                                                    </Button>
                                                </Col>
                                            </FormGroup>

                                            

                                        </Col>
                                    </Row>  
                                
                            
                            
                                }
                                
                                

                                
                                
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        )
    }


}

export default StudentHomeAddressInformation;

